module.exports = __webpack_public_path__ + "media/images/Northern-Lights-in-Night-Sky-7202d4e54dcb0316ef13f383fdb2ca01.jpg";